"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// creates a special function named ID, which returns the specified value as result
function idFunction(type, value) {
    return { id: 'id', type, value };
}
exports.idFunction = idFunction;
//# sourceMappingURL=bytecode.js.map